import { type IContactDisposition } from "@apis/prospects/types"
import type { IValueLabel } from "./types"

export const transformContactDispositionData = (
  data: IContactDisposition[],
): IValueLabel[] =>
  data.map((disposition) => ({
    value: disposition.disposition_code || "__none__",
    label: disposition.disposition_code || "__none__",
  }))
